import PaymentCreate from '@/controllers/payment/payment-create';
import { maxLength } from 'vuelidate/lib/validators';

export default {
  extends: PaymentCreate,
  name: 'customPaymentCreate',

  data() {
    const base = PaymentCreate.data.call(this);
    return {
      ...base,
      errors: null,
      paymentData: {
        ...base.paymentData,
        invoice_number: '',
      },
    };
  },

  validations() {
    const rules = PaymentCreate.validations.call(this);
    return {
      ...rules,
      paymentData: {
        ...rules.paymentData,
        invoice_number: {
          maxLength: maxLength(20),
        },
      },
    };
  },
};
